// // React 및 Chakra UI 관련 라이브러리 임포트
// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Flex, Table, Checkbox, Tbody, Td, Text, Button, Th, Thead, Tr,
//   useColorModeValue, Input, Box, List, ListItem
// } from "@chakra-ui/react";
// import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
// import Card from "components/card/Card";
// import Menu from "components/menu/MainMenu";
// import API_BASE_URL from "config/api";

// export default function CheckTable({ itemid }) {
//   const [columnsData, setColumnsData] = useState([
//     { Header: 'Inventory Name', accessor: 'name' },
//     { Header: 'Current Quantity', accessor: 'current_quantity' },
//     { Header: 'Unit', accessor: 'unit' },
//     { Header: 'Category', accessor: 'category' },
//   ]);
//   const [tableData, setTableData] = useState([]);
//   const [showInput, setShowInput] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [inventoryOptions, setInventoryOptions] = useState([]);
//   const [selectedInventory, setSelectedInventory] = useState(null);
//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

//   // 특정 제품에 연결된 inventory 데이터만 불러오기
//   const fetchInventoryData = async () => {
//     try {
//       const token = localStorage.getItem('access_token');
//       const response = await fetch(`${API_BASE_URL}/api/products/${itemid}/inventories/`, {  // `product` 파라미터로 특정 제품의 데이터만 가져오기
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const data = await response.json();
        
//         setTableData(data);  // 테이블 데이터에 특정 제품의 inventory만 설정
//       } else {
//         console.error("Error fetching inventory data");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   useEffect(() => {
//     if (itemid) {
//       console.log("Fetching data for itemid:", itemid);
//       fetchInventoryData();  // `itemid`가 변경되면 데이터를 다시 불러옵니다
//     }
//   }, [itemid]);
//   useEffect(() => {
//     console.log("Updated Table Data:", tableData); // tableData가 변경될 때마다 데이터 로그 출력
//   }, [tableData]); 
//   // 검색 쿼리로 전체 inventory 항목 가져오기
//   const fetchInventoryOptions = async (query) => {
//     try {
//       const token = localStorage.getItem('access_token');
//       const response = await fetch(`${API_BASE_URL}/api/inventory/?search=${query}`, {  // 전체 inventory를 검색할 때 `search` 파라미터 사용
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setInventoryOptions(data);  // 검색 결과를 드롭다운 메뉴에 표시
//       } else {
//         console.error("Unauthorized access - Invalid or missing token");
//       }
//     } catch (error) {
//       console.error("Error fetching inventory:", error);
//     }
//   };

//   useEffect(() => {
//     if (searchQuery) {
//       fetchInventoryOptions(searchQuery);  // 검색어가 입력되면 해당 쿼리에 맞는 전체 inventory 불러오기
//     } else {
//       setInventoryOptions([]);  // 검색어가 없을 경우 목록 초기화
//     }
//   }, [searchQuery]);

//   // 목록에서 항목을 선택했을 때
//   const handleItemClick = (item) => {
//     setSelectedInventory(item);
//     setSearchQuery(item.name);  // 선택한 항목의 이름을 검색 창에 표시
//   };

//   // 선택된 inventory를 테이블에 업데이트
//   const updateInventoryInTable = async () => {
//     if (selectedInventory) {
//       const inventoryData = {
//         name: selectedInventory.name,
//         quantity: selectedInventory.quantity,
//         price: selectedInventory.price,
//         currency: 'USD',  // 예시 필드
//         purchase_cycle: 'monthly',  // 예시 필드
//         stock_level: selectedInventory.stock_level,
//         products: [itemid],  // 현재 itemid를 products에 추가
//       };
  
//       try {
//         const token = localStorage.getItem('access_token');
//         const response = await fetch(`${API_BASE_URL}/api/inventory/${selectedInventory.id}/products/${itemid}/`, {  // 선택된 항목을 업데이트
//           method: 'PUT',
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(inventoryData),
//         });
  
//         if (response.ok) {
//           const data = await response.json();
//           console.log("Inventory updated successfully:", data);
//           fetchInventoryData();  // 업데이트 후 테이블을 새로고침
//         } else {
//           console.error("Error updating inventory:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Error:", error);
//       }
  
//       setShowInput(false);
//       setSearchQuery("");
//       setSelectedInventory(null);
//     }
//   };

//   const columns = useMemo(() => columnsData, [columnsData]);
//   const data = useMemo(() => tableData, [tableData]);
//   const tableInstance = useTable({
//     columns: columnsData,  // columnsData 사용
//     data: tableData,       // tableData 사용
//   }, useGlobalFilter, useSortBy, usePagination);
//   return (
//     <Card direction="column" w="100%" px="0px" overflowX={{ sm: "scroll", lg: "hidden" }}>
//       <Flex px="25px" justify="space-between" mb="20px" align="center">
//         <Text color={textColor} fontSize="22px" fontWeight="700">Inventory and Components</Text>
//         <Button
//           variant="action"
//           onClick={() => {
//             setShowInput(!showInput);
//             console.log("Append button clicked, showInput:", !showInput);
//           }}
//         >
//           Append
//         </Button>
//         <Menu />
//       </Flex>
      
//       {/* 입력 필드와 검색 목록 */}
//       {showInput && (
//         <Box px="25px" mb="20px">
//           <Input
//             placeholder="Search inventory..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}  // 검색어 입력
//           />
//           {inventoryOptions.length > 0 && (
//             <List mt="5px" border="1px solid" borderColor={borderColor} borderRadius="md">
//               {inventoryOptions.map((item) => (
//                 <ListItem
//                   key={item.id}
//                   p="5px"
//                   _hover={{ bg: "gray.100" }}
//                   onClick={() => handleItemClick(item)}  // 항목 클릭 시
//                 >
//                   {item.name}
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       )}

//       {/* Add 버튼 생성 */}
//       {selectedInventory && (
//         <Button onClick={updateInventoryInTable}>Add {selectedInventory.name} to Table</Button> // 선택된 inventory를 테이블에 추가하는 버튼
//       )}

//       {/* 테이블 */}
//       <Table {...tableInstance.getTableProps()} variant="simple" color="gray.500" mb="24px">
//         <Thead>
//           {tableInstance.headerGroups.map((headerGroup) => (
//             <Tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
//               {headerGroup.headers.map((column) => (
//                 <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={column.id}>
//                   <Flex justify="space-between" align="center">
//                     {column.render("Header")}
//                   </Flex>
//                 </Th>
//               ))}
//             </Tr>
//           ))}
//         </Thead>
//         <Tbody {...tableInstance.getTableBodyProps()}>
//           {tableInstance.page.map((row) => {
//             tableInstance.prepareRow(row);
//             console.log("Table rows:", tableInstance.page);
//             return (
//               <Tr {...row.getRowProps()} key={row.id}>
//                 {row.cells.map((cell) => (
//                   <Td {...cell.getCellProps()} key={cell.column.id}>
//                     {cell.render("Cell")}
//                   </Td>
//                 ))}
//               </Tr>
//             );
//           })}
//         </Tbody>
//       </Table>
//     </Card>
//   );
// }
import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "components/ui/card";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";
import { cn } from "lib/utils";
import API_BASE_URL from "config/api";
import { Search, Plus } from "lucide-react";

export default function InventoryandComponentsTable({ itemid }) {
  const [tableData, setTableData] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [selectedInventory, setSelectedInventory] = useState(null);

  // ✅ Fetch Inventory linked to the product
  const fetchInventoryData = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        `${API_BASE_URL}/api/products/${itemid}/inventories/`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setTableData(data);
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
    }
  };

  useEffect(() => {
    if (itemid) fetchInventoryData();
  }, [itemid]);

  // ✅ Search available inventory options
  const fetchInventoryOptions = async (query) => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        `${API_BASE_URL}/api/inventory/?search=${query}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setInventoryOptions(data);
      }
    } catch (error) {
      console.error("Error fetching inventory options:", error);
    }
  };

  useEffect(() => {
    if (searchQuery) fetchInventoryOptions(searchQuery);
    else setInventoryOptions([]);
  }, [searchQuery]);

  // ✅ Add selected inventory to table
  const updateInventoryInTable = async () => {
    if (!selectedInventory) return;
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        `${API_BASE_URL}/api/inventory/${selectedInventory.id}/products/${itemid}/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            products: [itemid],
          }),
        }
      );
      if (response.ok) {
        fetchInventoryData();
        setSearchQuery("");
        setSelectedInventory(null);
        setShowInput(false);
      }
    } catch (error) {
      console.error("Error updating inventory:", error);
    }
  };

  return (
    <Card className="bg-muted/40 border-border/60 text-foreground">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg font-semibold">
          Inventory and Components
        </CardTitle>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowInput(!showInput)}
          >
            <Plus className="w-4 h-4 mr-1" /> Append
          </Button>
        </div>
      </CardHeader>

      <CardContent>
        {/* === Search Input === */}
        {showInput && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <Search className="w-4 h-4 text-muted-foreground" />
              <Input
                placeholder="Search inventory..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="bg-background/60"
              />
            </div>
            {inventoryOptions.length > 0 && (
              <ul className="border border-border/50 rounded-lg p-2 bg-muted/30">
                {inventoryOptions.map((item) => (
                  <li
                    key={item.id}
                    className={cn(
                      "px-2 py-1 rounded-md cursor-pointer hover:bg-muted/60"
                    )}
                    onClick={() => {
                      setSelectedInventory(item);
                      setSearchQuery(item.name);
                    }}
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
            {selectedInventory && (
              <Button
                onClick={updateInventoryInTable}
                className="mt-3 w-full"
              >
                Add {selectedInventory.name}
              </Button>
            )}
          </div>
        )}

        {/* === Table === */}
        {tableData.length === 0 ? (
          <div className="py-12 text-center text-muted-foreground text-sm">
            No inventory data found.
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Inventory Name</TableHead>
                <TableHead>Current Quantity</TableHead>
                <TableHead>Unit</TableHead>
                <TableHead>Category</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.current_quantity}</TableCell>
                  <TableCell>{row.unit}</TableCell>
                  <TableCell>{row.category}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}